import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popup } from "@progress/kendo-react-popup";
import { alertNotification } from "../../actions/alertNotification";
import { addRelationData } from "../../actions/linkedTasks";
import { notifyIcon, number, quote } from "../../config";
import { popupAlign } from "../../helper/common";
import { LINKED_TASK } from "../TaskSidebar/TaskSidebarContent/LinkedSubTasks/LinkedTasks/linkTaskSearch.helper";
import { filteredLinkTask } from "../TaskSidebar/TaskSidebarContent/LinkedSubTasks/LinkedTasks/linkTaskSearch.helper";
import { addLinkTask, getLinkTaskDetails, handleTaskKeyUpdate } from "../Tasks/tasks.service";

const RelationList = (props) => {
  const {
    anchor,
    show,
    selectedItem,
    setShowPopup,
    relationListRef,
    blurTimeoutRef,
    setShow,
    onOpen,
    onFocus,
    onBlur,
    hashPopupVisible,
    isTriggeredByIcon,
    handlePopupClose,
  } = props;
  const dispatch = useDispatch();
  const { task, isNewTask } = useSelector((state) => state.taskSidebar),
    { relations } = useSelector((state) => state.linkedTasks),
    { childTask, parentTask, relatedTo } = useSelector((state) => state?.linkedTasks?.linkTask);
  const { user } = useSelector((state) => state.auth);

  /**  Set anchor alignment based on trigger type*/
  const anchorAlign = isTriggeredByIcon ? { horizontal: "left", vertical: "left" } : { horizontal: "bottom", vertical: "bottom" };

  /**  Set popup alignment based on trigger type*/
  const popupAlignment = isTriggeredByIcon ? popupAlign("left", "left") : popupAlign("top", "top");

  const addLinkTaskForNewTask = async (relationId) => {
    const payload = {
      linkTaskId: selectedItem?.Id,
      relationId: relationId,
    };
    let responseData = await getLinkTaskDetails(payload);
    await dispatch(addRelationData(relations));
    if (responseData) {
      const childData = [...childTask, responseData?.[number.ZERO]];
      const parentData = [...parentTask, responseData?.[number.ZERO]];
      const relatedData = [...relatedTo, responseData?.[number.ZERO]];
      let linkTask =
        relations &&
        relations?.find((r) => {
          return responseData?.[number.ZERO]?.SortOrder === r.relationOrder;
        });
      filteredLinkTask(childData, parentData, relatedData, linkTask?.relationName);
      linkTask?.relationName === LINKED_TASK.PARENT_TASK && handleTaskKeyUpdate(isNewTask, "parentLinkTaskCount", number.ONE);
    }
  };
  const addLinkTaskForExistingTask = async (relationId) => {
    if (relationId) {
      const payload = {
        linkTaskId: selectedItem.Id,
        taskId: task.taskId,
        relationId: relationId,
        userId: user?.id,
      };
      const response = await dispatch(addLinkTask(payload));
      if (response) {
        const linkTask =
          relations &&
          relations?.find((r) => {
            return response?.SortOrder === r.relationOrder;
          });
        let childData = [...childTask, response];
        let parentData = [...parentTask, response];
        let relatedData = [...relatedTo, response];
        filteredLinkTask(childData, parentData, relatedData, linkTask?.relationName);
        linkTask?.relationName === LINKED_TASK.PARENT_TASK && handleTaskKeyUpdate(isNewTask, "parentLinkTaskCount", number.ONE);
      }
    } else await dispatch(alertNotification(true, quote.SELECT_LINK_TYPE, notifyIcon.WARNING_ICON));
  };
  const handleLinkedTaskClick = async (relationId) => {
    if (isNewTask) addLinkTaskForNewTask(relationId);
    else addLinkTaskForExistingTask(relationId);
    if (handlePopupClose) {
      handlePopupClose();
    } else {
      setShow(false);
    }
    setShowPopup(false);
  };

  /**
   * closes the popup
   * @param {void}
   * @return {void}
   * @author Muskan Thakur
   */
  const hideOnBlur = () => {
    if (handlePopupClose) {
      handlePopupClose();
    } else {
      setShow(false);
    }
  };

  /**  Handle mouse leave on popup to close it
   * @author Muskan Thakur
   */
  const handlePopupMouseLeave = () => {
    if (handlePopupClose) {
      handlePopupClose();
    } else {
      setShow(false);
    }
  };

  return (
    <>
      <Popup
        anchor={anchor.current}
        show={show}
        appendTo={anchor.current}
        anchorAlign={anchorAlign}
        popupAlign={popupAlignment}
        onOpen={() => onOpen(relationListRef)}>
        <div
          ref={relationListRef}
          tabIndex={number.ZERO}
          onFocus={() => onFocus(blurTimeoutRef)}
          onBlur={() => onBlur(blurTimeoutRef, hideOnBlur)}
          onMouseLeave={handlePopupMouseLeave}>
          <ul className={`m-0 p-0 ${hashPopupVisible ? "relation-list-popup" : "relation-list"}`}>
            {relations &&
              relations?.map((r, i) => (
                <li
                  className='cursor-pointer text-center text-nowrap'
                  onClick={() => {
                    handleLinkedTaskClick(r.relationId);
                  }}
                  key={i}>
                  {r.relationName}
                </li>
              ))}
          </ul>
        </div>
      </Popup>
    </>
  );
};
export default RelationList;
